import React, { Component } from 'react';
import { Row, Col, Card, Form, Label } from 'reactstrap';
import Dropzone from 'react-dropzone';
import { Link } from 'react-router-dom';
import { isVideoExtension } from '../helpers/expression-checker';
import { FaVideo, FaImage } from 'react-icons/fa';

class FormUpload extends Component {
  constructor(props) {
    super(props);
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    this.state = {
      selectedFiles: []
    };
  }

  handleAcceptedFiles = (files) => {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size)
      })
    );
    
    if (this.props.setImage) {
      this.props.setImage(files[0]);
    }
    
    if (this.props.setImages) {
      this.props.setImages(files);
    }
    
    this.setState({ selectedFiles: files });
  };

  /**
   * Formats the size
   */
  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

  render() {
    return (
      <React.Fragment>
        <Dropzone
          onDrop={(acceptedFiles) => this.handleAcceptedFiles(acceptedFiles)}
          accept={
            this.props.pdf
              ? {
                  'application/pdf': ['.pdf']
                }
              : this.props.video
                ? {
                    'image/*': ['.jpeg', '.jpg', '.png'],
                    'video/*': ['.mp4', '.mov', '.mkv']
                  }
                : {
                    'image/*': ['.jpeg', '.jpg', '.png']
                  }
          }
        >
          {({ getRootProps, getInputProps }) => (
            <div className="dropzone">
              <div
                className="dz-message needsclick mt-2"
                {...getRootProps()}
              >
                <input {...getInputProps()} />
                <div className="mb-3">
                  <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                </div>
                <h5>{this.props.title}</h5>
                <p className="text-muted">Drag & drop files here or click to upload</p>
                <div className="d-flex justify-content-center mt-2">
                  <span className="badge badge-light mr-2">
                    <FaImage className="mr-1" /> Images
                  </span>
                  {this.props.video && (
                    <span className="badge badge-light">
                      <FaVideo className="mr-1" /> Videos
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
        </Dropzone>
        <div className="dropzone-previews mt-3" id="file-previews">
          {this.state.selectedFiles.map((f, i) => {
            const isVideo = f.name && 
              (f.name.endsWith('.mp4') || 
               f.name.endsWith('.mov') || 
               f.name.endsWith('.mkv'));
            
            return (
              <Card
                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                key={i + '-file'}
              >
                <div className="p-2">
                  <Row className="align-items-center">
                    <Col className="col-auto">
                      {isVideo ? (
                        <div className="bg-light rounded d-flex align-items-center justify-content-center" 
                             style={{ width: 80, height: 80 }}>
                          <FaVideo size={24} className="text-secondary" />
                        </div>
                      ) : (
                        <img
                          data-dz-thumbnail=""
                          height="80"
                          className="avatar-sm rounded bg-light"
                          alt={f.name}
                          src={f.preview}
                        />
                      )}
                    </Col>
                    <Col>
                      <div className="text-truncate">
                        <strong>{f.name}</strong>
                      </div>
                      <div>
                        <span className="text-muted">{f.formattedSize}</span>
                        {isVideo && (
                          <span className="badge badge-info ml-2">Video</span>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
            );
          })}
        </div>
      </React.Fragment>
    );
  }
}

export default FormUpload;